import { detect } from 'detect-browser';

/**
 * @category Utils
 */
export const read = async (result: number): Promise<any> => {
  let readResult;
  let deleteResult;
  let keyToReturn;

  while (!readResult && !deleteResult) {
    try {
      readResult = await readKey(`/privid/${result}`);
    } catch (e) {
      clearDB();
    }

    if (readResult !== undefined) {
      keyToReturn = readResult;
      deleteResult = await clearDB();
    } else {
      console.log('------------here------------');
    }
  }
  return keyToReturn;
};

/**
 * @category Utils
 */
export function readKey(key: string): Promise<any> {
  const indexedDB =
    window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  if (!indexedDB) return Promise.reject(new Error('IndexedDB not available'));
  return new Promise((resolve, reject) => {
    const open = indexedDB.open('/privid-wasm', 21);

    open.onerror = function () {
      resolve(false);
      console.log('Failing here');
    };

    open.onupgradeneeded = function () {
      open.result.createObjectStore('/privid-wasm');
    };

    open.onsuccess = function () {
      try {
        const db = open.result;
        const tx = db.transaction('/privid-wasm', 'readwrite');
        const store = tx.objectStore('/privid-wasm');
        const getKey = store.get(key);

        getKey.onsuccess = function () {
          resolve(getKey.result);
        };

        tx.onerror = function () {
          reject(tx.error);
        };

        tx.oncomplete = function () {};
      } catch (e) {
        //
      }
    };
  });
}

export const clearCache = async () => {
  localStorage.clear();

  const req = window.indexedDB.deleteDatabase('/privid');
  req.onsuccess = function () {};
  req.onerror = function () {};
  req.onblocked = function () {};
  const req2 = window.indexedDB.deleteDatabase('/privid_wasm');
  req2.onsuccess = function (e) { console.log("success", e)};
  req2.onerror = function (e) { console.log("error", e)};
  req2.onblocked = function (e) { console.log("blocked", e)};
  const req3 = window.indexedDB.deleteDatabase('emscripten_filesystem');
  req3.onsuccess = function () {};
  req3.onerror = function () {};
  req3.onblocked = function () {};
};

/**
 * This function clears the local database
 * @category Utils
 */
export async function clearDB(): Promise<string> {
  // const billing_skumap = await readKey(`/privid/billing_skumap.json`);
  const { name: browserName, os } = detect();

  const req = window.indexedDB.deleteDatabase('/privid');
  req.onsuccess = function () {};
  req.onerror = function () {};
  req.onblocked = function () {};
  const req2 = window.indexedDB.deleteDatabase('/privid_wasm');
  req2.onsuccess = function () {};
  req2.onerror = function () {};
  req2.onblocked = function () {};
  const req3 = window.indexedDB.deleteDatabase('emscripten_filesystem');
  req3.onsuccess = function () {};
  req3.onerror = function () {};
  req3.onblocked = function () {};
  const indexedDB =
    window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  if (!indexedDB) return Promise.reject(new Error('IndexedDB not available'));
  return new Promise((resolve, reject) => {
    const open = indexedDB.open('/privid', 21);

    open.onerror = function () {
      reject(open.error);
    };

    open.onupgradeneeded = function () {
      open.result.createObjectStore('FILE_DATA');
    };

    open.onsuccess = function () {
      try {
        const db = open.result;
        const tx = db.transaction('FILE_DATA', 'readwrite');
        const store = tx.objectStore('FILE_DATA');
        let getKey = null;
        // if(result !== undefined) getKey = store.delete(result);
        getKey = store.clear();

        // store.put(billing_skumap, '/privid/billing_skumap.json');

        tx.onerror = function () {
          reject(tx.error);
        };

        tx.oncomplete = function () {
          try {
            db.close();
          } catch (e) {
            //
          }
          resolve('deleted');
        };
      } catch (e) {
        //
      }
    };
  });
}
